import React from "react";

export default function NextArrow() {
  return (
    <svg width="36" height="60" viewBox="0 0 36 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 2L34 30L2 58"
        stroke="#828282"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
